import type { QueryClient } from "@tanstack/react-query";
import type { RouteObject } from "react-router-dom";

import { AnalysisAssistRoutes } from "@/features/analysis-assist/routes/analysis-assist-routes";
import { ConnectSettingsRoutes } from "@/features/connect-settings/routes/connect-settings-routes";
import { PlaceholderManagementRoutes } from "@/features/placeholder-management/routes/placeholder-management-routes";
import { TenantManagementRoutes } from "@/features/tenant-management/routes/tenant-management-routes";

export const commonRoutes: (queryClient: QueryClient) => RouteObject[] = (
  queryClient: QueryClient
) => [
  // テナント管理（ホスト向け）
  ...TenantManagementRoutes(queryClient),
  // プレースホルダ管理（ホスト向け）
  ...PlaceholderManagementRoutes(queryClient),
  // Connect設定画面
  ...ConnectSettingsRoutes(queryClient),
  // 分析アシスト
  ...AnalysisAssistRoutes(queryClient),
];
